<template>
   <div class="crud-wrapper">

      <crud-toolbar :modalMode="modalMode" :newState="newState" :showBack="false" :title="modalTitle"
                    @onCommand="toolbarCommand"></crud-toolbar>

      <crud-form :modal-mode="modalMode" :ref="formName" fullWidth v-model="validForm">
         <v-card flat>
            <v-form>
               <v-subheader style="height: 25px;">{{contact.name}}</v-subheader>
               <v-subheader style="height: 25px;">{{contact.phone}}</v-subheader>
               <!--<v-autocomplete
                       :items="['Trevor Handsen', 'Alex Nelson']"
                       chips
                       full-width
                       hide-details
                       hide-no-data
                       hide-selected
                       label="To"
                       multiple
                       single-line
                       v-model="selected"
               ></v-autocomplete>-->
               <v-divider></v-divider>
               <v-textarea autofocus counter full-width label="mensagem" maxlength="120" single-line
                           v-model="message"></v-textarea>
            </v-form>
         </v-card>

      </crud-form>

   </div>
</template>

<script>

    import CrudFormClass from '@consigmais-team/vue-common/layout/crudPage/crudFormClass';

    export default CrudFormClass.extend({
        name: 'sendSMS',

        props: {
            contact: {
                type: Object,
                required:true
            }
        },

        data () {
            return {
                formName: 'sendSMS',

                formData: {
                    message: null,
                    login_pin: null
                }
            };
        },

        methods: {
            save () {
                this.validateForm()
                    .then(() => {
                        auth.changePassword(this.formData).then(data => {
                            this.$store.dispatch('company/stSetPinChanged');

                            this.$notifyUser({
                                type: 'success',
                                message: 'Senha alterada com sucesso!'
                            });

                            if (this.modalMode) {
                                this.$emit('onDataSaved', data);
                            }

                        });

                    })
                    .catch(() => {
                        this.$notifyUser({
                            type: 'error',
                            message: this.$t('appMsg.invalidForm')
                        });
                    });

            }

        },

        mounted () {
            console.log('SendSMS!', this.modalMode);
        }

    });
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/SendSMS.vue